// extracted by mini-css-extract-plugin
module.exports = {"quickLinks":"_8ba0bfb","list":"_d7f31d3","settings":"_b639ca8"};